import React from "react";
import { InlineWidget } from "react-calendly";
import { Helmet } from "react-helmet-async";
import { Reveal } from "../../Components/Reveal/Reveal";
export const Booking = () => {
  return (
    <>
      <Helmet>
        <title>Book Now to Unlock Your Potential - DataDept</title>
        <meta
          name="description"
          content="Reach out to DataDept for custom software development and IT consulting. Contact us today to discuss your project needs and discover how we can drive your business forward."
        />
        <link rel="canonical" href="/terms-conditions" />
      </Helmet>
      <section className="about-page-section-1 container-style">
        <div className="content-sizing about-page-section-1-wrapper">
          <div className="header-into-about-section">
            <Reveal delay={0.1}>
              <span className="light-tag">Appointment Booking</span>
            </Reveal>
            <Reveal delay={0.2}>
              <h1 className="header-tag-about">
                Book Now to Unlock Your Potential
              </h1>
            </Reveal>
            <Reveal delay={0.2}>
              <h2 className="sub-header-tag-about">
                Schedule Your Consultation Today – Unleash the Power of Expert
                Software Development & IT Solutions
              </h2>
            </Reveal>
          </div>
        </div>
      </section>
      <InlineWidget
        url="https://calendly.com/datadept-ca/30min"
        styles={{ height: "800px" }}
      />
    </>
  );
};
